import { z } from 'zod';
import { TenantMembershipRole } from '@tangible/shared';

// A tenant member with the role from its tenant membership
// (/members-api/members/ and, for the current user, /auth/current-account/).
export const User = z.object({
  id: z.number(),
  account_id: z.uuidv4().nullable(),
  email: z.email(),
  role: TenantMembershipRole.nullable(),
  created_at: z.iso.datetime(),
});

export type User = z.infer<typeof User>;
